var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.403 10.673a1.713 1.713 0 1 0 .61.644",
    stroke: "#35404A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.826 12.22.41.37a.18.18 0 0 0 .27-.036l.666-1.033",
    stroke: "#31B59F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.377 14.285.499.566m.24-1.726.753.077m-2.746 1.638-.036.756",
    stroke: "#31B59F",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.58 2.46h.001a.024.024 0 0 1 .019.024c0 2.98-.808 5.262-1.817 6.952A2.675 2.675 0 0 0 8.84 12.77c-.28.215-.519.377-.695.49-.204.129-.323.19-.323.19v.001a.024.024 0 0 1-.022 0s-.091-.042-.252-.135a8.203 8.203 0 0 1-.659-.426 10.848 10.848 0 0 1-1.987-1.844C3.462 9.337 2.02 6.601 2.02 2.484c0-.011.007-.022.019-.024C4.103 2.007 5.326 1.364 6.21.9L6.21.899c.697-.366 1.13-.587 1.6-.587.469 0 .902.22 1.598.587.883.464 2.107 1.107 4.172 1.561z",
    stroke: "#35404A",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.043 7.33H4.7a.108.108 0 0 1-.108-.108v-.651l.001-.014A.7.7 0 0 1 5.278 6h.258c.026 0 .05-.01.069-.028l.723-.705a.83.83 0 0 1 .437-.223l.285-.05a4.516 4.516 0 0 1 1.503-.007c.402.066.776.247 1.077.52l.398.362c.005.005.01.009.017.011l1.054.457a.679.679 0 0 1 .409.622v.262c0 .06-.049.109-.109.109h-.468m-2.479 0h-.921m-.642 0a.598.598 0 1 1-1.196 0 .598.598 0 0 1 1.196 0zm3.401 0a.598.598 0 1 1-1.196 0 .598.598 0 0 1 1.196 0z",
    stroke: "#31B59F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.bc7ab2c9bf37a37bb4c9c80fcec34087.svg";
export { ForwardRef as ReactComponent };